import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle
} from "@chakra-ui/alert"
import { ShowsErrorMessageType } from "../../../recoil/atoms/shows/types"

type ShowsErrorMessageProps = ShowsErrorMessageType

const ShowsErrorMessage = ({ title, message }: ShowsErrorMessageProps) => {
  return (
    <Alert
      status="error"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="100%"
    >
      <AlertIcon boxSize="40px" mr={0} />
      <AlertTitle mt={4} mb={1} fontSize="lg">
        {title}
      </AlertTitle>
      <AlertDescription maxWidth="lg">{message}</AlertDescription>
    </Alert>
  )
}

export default ShowsErrorMessage
